module.exports = __webpack_public_path__ + "static/media/luberly_4.0ce8a268.png";